import { render, staticRenderFns } from "./WaitingForArrival.vue?vue&type=template&id=e679031c&scoped=true&"
import script from "./WaitingForArrival.vue?vue&type=script&lang=js&"
export * from "./WaitingForArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e679031c",
  null
  
)

export default component.exports